import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { toHTTPParam } from '../../../../../core';
import { ConfigServerService, CustomHttp } from '../../../../../core';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeUpdateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Atualiza o responsável pela oportunidade */
    updateResponsavel(id: number, idUsuarioResponsavel: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/responsavel/${idUsuarioResponsavel}`, null);
    }

    /** Atualiza a prioridade da oportunidade */
    updatePrioridade(id: number, prioridade: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/prioridade/${prioridade}`, null);
    }

    /** Atualiza o valor da oportunidade */
    updateValor(id: number, valor: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/valor/${valor}`, null);
    }

    /** Atualiza a previsão de fechamento da oportunidade */
    updatePrevisaoFechamento(id: number, dataPrevisaoFechamento: Date): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/previsaofechamento/${toHTTPParam(dataPrevisaoFechamento, true)}`, null);
    }

    /** Atualiza a campanha da oportunidade */
    updateCampanha(id: number, idCampanha: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${id}/campanha/${idCampanha}`, null);
    }
}
